export type Language = (typeof I18nHelper.SUPPORTED_LANGUAGES)[number];

// enum for Language could also be used
export const ELanguage: { [key in Language]: key } = {
  fr: "fr",
  en: "en",
};

export default class I18nHelper {
  static SUPPORTED_LANGUAGES = ["fr", "en"] as const;
  static DEFAULT_LANGUAGE: Language = "fr";

  static getLangFromPath = (pathname: string): Language => {
    const firstSegment = pathname.split("/")[1];

    if (I18nHelper.SUPPORTED_LANGUAGES.includes(firstSegment as Language)) {
      return firstSegment as Language;
    }

    return I18nHelper.DEFAULT_LANGUAGE;
  };

  static removeLangFromPath = (pathname: string): string => {
    const segments = pathname.split("/").filter(Boolean);

    if (I18nHelper.SUPPORTED_LANGUAGES.includes(segments[0] as Language)) {
      segments.shift();
    }

    return `/${segments.join("/")}`;
  };

  static getLangHref = (pathname: string, targetLang: Language): string => {
    const cleanPath = I18nHelper.removeLangFromPath(pathname);

    if (targetLang === I18nHelper.DEFAULT_LANGUAGE) {
      /* No prefix for default language */
      return cleanPath;
    }

    // Other language → prefix + cleaned pathname
    return cleanPath === "/" ? `/${targetLang}` : `/${targetLang}${cleanPath}`;
  };
}
